/* eslint semi: 1 */

import { fromPairs, keys } from 'lodash';

import { CLOSE_DIALOG } from '@/components/common/dialog-popup/dialog-popup';

export const CLOSE_SETUP_EVENT = 'PlayerSetupDialogClose';

export const PLAYER_SETUP_STEPS = {
  STEP_PLAN_SUMMARY: 'playerPlanSummary',
  STEP_SERIAL: 'serial',
  STEP_PIN: 'pin',
  STEP_NAME: 'name',
  STEP_APPLICATION: 'application',
  STEP_RESOLUTION: 'resolution',
  STEP_ARRANGEMENT: 'arrangement',
  STEP_ADJUSTMENTS: 'adjustments',
  CLOSE: CLOSE_DIALOG
};

export const PROGRESS_SCENARIOS = {
  SINGLE_DISPLAY: [
    { id: PLAYER_SETUP_STEPS.STEP_PIN, i18nLabel: 'playerSetup.Progress_PIN' },
    { id: PLAYER_SETUP_STEPS.STEP_NAME, i18nLabel: 'playerSetup.Progress_Name' },
    { id: PLAYER_SETUP_STEPS.STEP_RESOLUTION, i18nLabel: 'playerSetup.Progress_DisplaySettings' }
  ],
  MULTI_OUTPUTS: [
    { id: PLAYER_SETUP_STEPS.STEP_PIN, i18nLabel: 'playerSetup.Progress_PIN' },
    { id: PLAYER_SETUP_STEPS.STEP_NAME, i18nLabel: 'playerSetup.Progress_Name' },
    { id: PLAYER_SETUP_STEPS.STEP_APPLICATION, i18nLabel: 'playerSetup.Progress_Application' },
    { id: PLAYER_SETUP_STEPS.STEP_RESOLUTION, i18nLabel: 'playerSetup.Progress_DisplaySettings' }
  ],

  LED: [
    { id: PLAYER_SETUP_STEPS.STEP_PIN, i18nLabel: 'playerSetup.Progress_PIN' },
    { id: PLAYER_SETUP_STEPS.STEP_NAME, i18nLabel: 'playerSetup.Progress_Name' },
    { id: PLAYER_SETUP_STEPS.STEP_APPLICATION, i18nLabel: 'playerSetup.Progress_Application' },
    { id: PLAYER_SETUP_STEPS.STEP_RESOLUTION, i18nLabel: 'playerSetup.Progress_DisplaySettings' },
    { id: PLAYER_SETUP_STEPS.STEP_ARRANGEMENT, i18nLabel: 'playerSetup.Progress_Arrangement' },
    { id: PLAYER_SETUP_STEPS.STEP_ADJUSTMENTS, i18nLabel: 'playerSetup.Progress_Adjustments' }
  ],
  VIDEO_WALL: [
    { id: PLAYER_SETUP_STEPS.STEP_PIN, i18nLabel: 'playerSetup.Progress_PIN' },
    { id: PLAYER_SETUP_STEPS.STEP_NAME, i18nLabel: 'playerSetup.Progress_Name' },
    { id: PLAYER_SETUP_STEPS.STEP_APPLICATION, i18nLabel: 'playerSetup.Progress_Application' },
    { id: PLAYER_SETUP_STEPS.STEP_RESOLUTION, i18nLabel: 'playerSetup.Progress_DisplaySettings' },
    { id: PLAYER_SETUP_STEPS.STEP_ARRANGEMENT, i18nLabel: 'playerSetup.Progress_Arrangement' },
    { id: PLAYER_SETUP_STEPS.STEP_ADJUSTMENTS, i18nLabel: 'playerSetup.Progress_Adjustments' }
  ],
  MIRRORING: [
    { id: PLAYER_SETUP_STEPS.STEP_PIN, i18nLabel: 'playerSetup.Progress_PIN' },
    { id: PLAYER_SETUP_STEPS.STEP_NAME, i18nLabel: 'playerSetup.Progress_Name' },
    { id: PLAYER_SETUP_STEPS.STEP_APPLICATION, i18nLabel: 'playerSetup.Progress_Application' },
    { id: PLAYER_SETUP_STEPS.STEP_RESOLUTION, i18nLabel: 'playerSetup.Progress_DisplaySettings' }
    // { id: PLAYER_SETUP_STEPS.CLOSE, i18nLabel: 'playerSetup.Progress_Arrangement' },
    // { id: PLAYER_SETUP_STEPS.CLOSE, i18nLabel: 'playerSetup.Progress_Adjustments' }
  ]
};

// let's have it to avoid typos in the code
export const PROGRESS_SCENARIO_OPTIONS = fromPairs(keys(PROGRESS_SCENARIOS).map(k => [k, k]));
